<template>
  <div style="background-color: #fff; padding: 0 10px 10px 10px">
    <!-- 搜索 -->
    <div ref="topDom" class="header-bar">
      <div class="bar-lef">
        <div class="lef-one">
          <a-select
              v-model:value="searchForm.status"
              allowClear
              placeholder="状态"
              @change="getTableData"
          >
            <a-select-option :value="0">待上报</a-select-option>
            <a-select-option :value="1">上报中</a-select-option>
            <a-select-option :value="2">上报成功</a-select-option>
            <a-select-option :value="3">上报失败</a-select-option>
          </a-select>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.order_no"
              allowClear placeholder="订单号|外部单号"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.hid"
              allowClear
              placeholder="房间ID"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input
              v-model:value="searchForm.guestCode"
              allowClear
              placeholder="旅客编码"
          >
          </a-input>
        </div>
        <div class="lef-one">
          <a-input-search
              v-model:value="searchForm.keyword"
              :loading="searchLoading"
              placeholder="房间名称|姓名|手机号|证件号"
              @search="getTableData"
          >
          </a-input-search>
        </div>
        <div class="lef-one-no-shadow">
          <a-button type="link" @click="handleReset">重置筛选</a-button>
        </div>
      </div>
      <div class="bar-rig">
        <div class="rig-one">
          <a-popover
              v-model:visible="visiblePopover"
              placement="bottom"
              trigger="click"
          >
            <template #content>
              <template v-for="(item, index) in initColumns" :key="index">
                <div v-if="item.title" style="margin: 5px 0">
                  <a-checkbox v-model:checked="item.isShow">{{
                      item.title
                    }}
                  </a-checkbox>
                </div>
              </template>
              <a-button
                  size="small"
                  style="margin-right: 5px"
                  @click="handleResetCheck"
              >重置
              </a-button
              >
              <a-button class="btn-primary" size="small" @click="handleCheck"
              >确认
              </a-button
              >
            </template>
            <a-button>
              <appstore-outlined/>
              视图
            </a-button>
          </a-popover>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="searchLoading"
        :pagination="false"
        :scroll="{ x: columns.length > 8 ? columns.length*130 : 0, y: tableHeight }"
        bordered
        class="table"
        size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key == 'order_no'">
          <a-button
              type="link"
              @click="
              detShow = true;
              orderId = record.order_id;
            "
          >{{ record.order_no }}
          </a-button
          >
        </template>
        <template v-if="column.key == 'status_text'">
          <span v-if="record.status == 1" class="f-c-red">{{ record.status_text }}</span>
          <span v-else-if="record.status == 2" class="f-c-green">{{ record.status_text }}</span>
          <span v-else class="f-c-red">{{ record.status_text }}</span>
        </template>
      </template>
    </a-table>

    <!-- 分页 -->
    <MyPagination
        :pageTotal="pageTotal"
        @onShowSizeChange="onShowSizeChange"
        @pageChange="pageChange"
    />
    <!-- 订单详情 -->
    <order-details
        v-model:visible="detShow"
        :orderId="orderId"
        @refreshOrderDetails="refresh"
    />
  </div>
</template>

<script>
import {nextTick, onMounted, reactive, toRefs, watch} from "vue";
import {guotaiCheckIn,} from "@/api/api";
import {AppstoreOutlined,} from "@ant-design/icons-vue";
import useUtils from "@/hooks/useUtils.js"; //工具库
import store from "@/store/pms/landlord/index";
import OrderDetails from "@/components/pms/landlord/OrderDetails/OrderDetails.vue";

export default {
  components: {
    OrderDetails,
    AppstoreOutlined,
  },
  setup() {
    let {countTable} = useUtils();

    // 搜索
    const search = reactive({
      topDom: "",
      searchLoading: false,
      searchForm: {
        status: [],
        hid: '',
        guestCode: '',
        keyword: "",
        order_no: "",
        start: 0,
        limit: 20,
      },
      rangePicker: [],
      visiblePopover: false,
      searchList: {
        deposit: {},
        group: {},
        income: {},
        inout: {},
        paytype: {},
        room: {},
        source: {},
        tag: {},
      },
      handleReset() {
        search.searchForm.keyword = "";
        search.searchForm.order_no = "";
        search.searchForm.hid = "";
        search.searchForm.status = "";
        search.searchForm.guestCode = "";
        table.getTableData();
      },
      handleCheck() {
        table.columns = table.initColumns.filter((item) => {
          return item.isShow;
        });
        search.visiblePopover = false;
      },
      handleResetCheck() {
        table.initColumns.map((item) => {
          item.isShow = true;
        });
        table.columns = JSON.parse(JSON.stringify(table.initColumns));
        search.visiblePopover = false;
      },
      groupFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
      roomFilter(input, option) {
        return (
            option.children[0].children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
        );
      },
    });

    function getColumns() {
      return [
        {
          title: "记录ID",
          dataIndex: "id",
          key: "id",
          width: 80,
          isShow: true,
          align: "center",
        },
        {
          title: "房间ID",
          dataIndex: "hid",
          key: "hid",
          width: 80,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "房间名称",
          dataIndex: "hname",
          key: "hname",
          width: 120,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "订单ID",
          dataIndex: "order_id",
          key: "order_id",
          width: 100,
          isShow: true,
          align: "center",
        },
        {
          title: "订单号",
          dataIndex: "order_no",
          key: "order_no",
          width: 120,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "登记ID",
          dataIndex: "tid",
          key: "tid",
          width: 100,
          isShow: true,
          align: "center",
        },
        {
          title: "房源编码",
          dataIndex: "roomCode",
          key: "roomCode",
          width: 100,
          isShow: true,
          align: "center",
        },
        {
          title: "商户编码",
          dataIndex: "hotelCode",
          key: "hotelCode",
          width: 100,
          isShow: true,
          align: "center",
        },
        {
          title: "旅客编码",
          dataIndex: "guestCode",
          key: "guestCode",
          width: 150,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "状态",
          dataIndex: "status_text",
          key: "status_text",
          width: 80,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: '苏州公安上报状态',
          dataIndex: 'szga_report_status',
          key: 'szga_report_status',
          width: 150,
          customRender({ record }) {
            const statusMap = {
              0: '待上报',
              1: '上报中',
              2: '上报成功',
              3: '上报失败',
            };
            return statusMap[record.szga_report_status] ?? record.szga_report_status_text ?? '-';
          },
        },
        {
          title: "上报时间",
          dataIndex: "create_time",
          key: "create_time",
          width: 130,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "上报备注",
          dataIndex: "remark",
          key: "remark",
          width: 150,
          isShow: true,
          align: "center",
          ellipsis: true,
        },
        {
          title: "姓名",
          dataIndex: "name",
          key: "name",
          width: 80,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "性别",
          dataIndex: "gender",
          key: "gender",
          width: 60,
          isShow: true,
          align: "center",
          customRender: ({record}) => {
            if (record.gender === 0) {
              return '男';
            } else {
              return '女';
            }
          },
        },
        {
          title: "出生日期",
          dataIndex: "birthday",
          key: "birthday",
          width: 80,
          isShow: true,
          align: "center",
        },
        {
          title: "民族",
          dataIndex: "gnname",
          key: "gnname",
          width: 100,
          isShow: true,
          align: "center",
        },
        {
          title: "证件类型",
          dataIndex: "gtname",
          key: "gtname",
          width: 100,
          isShow: true,
          align: "center",
        },
        {
          title: "证件号",
          dataIndex: "certNum",
          key: "certNum",
          width: 120,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "详细地址",
          dataIndex: "address",
          key: "address",
          width: 120,
          isShow: true,
          ellipsis: true,
          align: "center",
        },
        {
          title: "签发机关",
          dataIndex: "authority",
          key: "authority",
          width: 80,
          isShow: true,
          align: "center",
          ellipsis: true,
        },
        {
          title: "证件有效期",
          dataIndex: "validate1",
          key: "validate1",
          width: 120,
          isShow: true,
          align: "center",
          customRender: ({record}) => {
            return record.validate1 + '-' + record.validate2;
          },
        },
        {
          title: "签发次数",
          dataIndex: "qfcs",
          key: "qfcs",
          width: 80,
          isShow: true,
          align: "center",
          ellipsis: true,
        },
        {
          title: "比对分数",
          dataIndex: "semblance",
          key: "semblance",
          width: 60,
          isShow: true,
          align: "center",
        },
        {
          title: "比对结果",
          dataIndex: "faceResult",
          key: "faceResult",
          width: 60,
          isShow: true,
          align: "center",
          customRender: ({record}) => {
            if (record.faceResult === 1) {
              return '通过';
            } else {
              return '不通过';
            }
          },
        },
        {
          title: "手机号",
          dataIndex: "sjh",
          key: "sjh",
          width: 80,
          isShow: true,
          align: "center",
        },
        {
          title: "入住时间",
          dataIndex: "checkIn",
          key: "checkIn",
          width: 120,
          isShow: true,
          align: "center",
        },
        {
          title: "离店时间",
          dataIndex: "checkOut",
          key: "checkOut",
          width: 120,
          isShow: true,
          align: "center",
        },
        {
          title: "旅客类型",
          dataIndex: "guestType",
          key: "guestType",
          width: 60,
          isShow: true,
          ellipsis: true,
          align: "center",
          customRender: () => {
            return '境内旅客';
          },
        },
        {
          title: "是否未成年",
          dataIndex: "wcnflag",
          key: "wcnflag",
          width: 80,
          isShow: true,
          align: "center",
          customRender: ({record}) => {
            if (record.wcnflag == 1) {
              return '未成年';
            } else {
              return '已成年';
            }
          },
        },
        {
          title: "监护人关系",
          dataIndex: "jhrgx",
          key: "jhrgx",
          width: 100,
          isShow: true,
          align: "center",
          customRender: ({record}) => {
            if (record.jhrgx == 1) {
              return '父亲';
            } else if (record.jhrgx == 2) {
              return '母亲';
            } else if (record.jhrgx == 3) {
              return '老师';
            } else if (record.jhrgx == 9) {
              return '其他';
            } else {
              return '-';
            }
          },
        },
        {
          title: "监护人姓名",
          dataIndex: "jhrxm",
          key: "jhrxm",
          width: 80,
          isShow: true,
          align: "center",
        },
        {
          title: "监护人证件",
          dataIndex: "jhrsfzh",
          key: "jhrsfzh",
          width: 150,
          isShow: true,
          align: "center",
        },
        {
          title: "监护人电话",
          dataIndex: "jhrlxdh",
          key: "jhrlxdh",
          width: 80,
          isShow: true,
          align: "center",
        },
        {
          title: "是否可疑",
          dataIndex: "kyqk",
          key: "kyqk",
          width: 80,
          isShow: true,
          align: "center",
          customRender: ({record}) => {
            if (record.kyqk == 1) {
              return '是';
            } else {
              return '否';
            }
          },
        },
        {
          title: "可疑描述",
          dataIndex: "kyqkms",
          key: "kyqkms",
          width: 150,
          isShow: true,
          align: "center",
          ellipsis: true,
        },
        {
          title: "上报房间号",
          dataIndex: "roomNo",
          key: "roomNo",
          width: 100,
          isShow: true,
          align: "center",
        },
        {
          title: "订单类型",
          dataIndex: "orderType",
          key: "orderType",
          width: 60,
          isShow: true,
          align: "center",
          customRender: ({record}) => {
            if (record.orderType === 1) {
              return '旅客订单';
            } else {
              return '房东录入';
            }
          },
        },
      ];
    }

    // 分页;
    let pagination = reactive({
      pageTotal: 0,
      pageChange(value) {
        search.searchForm.start = (value - 1) * search.searchForm.limit;
        table.getTableData();
      },
      onShowSizeChange(value) {
        search.searchForm.limit = value;
        table.getTableData();
      },
    });

    // 表格
    const table = reactive({
      currentItem: {},
      tableHeight: "",
      dataSource: [],
      topData: {},
      initColumns: [],
      getTableData() {
        search.searchLoading = true;
        guotaiCheckIn(search.searchForm)
            .then((res) => {
              table.dataSource = res.data.list;
              pagination.pageTotal = res.data.count;
              nextTick(() => {
                table.columns = getColumns();
                table.initColumns = getColumns();
              });
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
      columns: getColumns(),
    });
    // 订单
    const order = reactive({
      detShow: false,
      orderId: "",
      refresh() {
        table.getTableData();
      },
    });


    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 80;
        }
    );

    onMounted(() => {
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 80;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(pagination),
      ...toRefs(order),
    };
  },
};
</script>

<style lang="scss" scoped>
.refund {
  .refund-switch {
    display: flex;
    align-items: center;
    cursor: pointer;

    .switch-lef {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 6px 0 0 6px;
      width: 100px;
      text-align: center;
    }

    .switch-rig {
      padding: 4px 8px;
      border: 1px solid #f2f2f2;
      border-radius: 0 6px 6px 0;
      width: 100px;
      text-align: center;
    }

    .refundSel {
      background-color: #1890ff;
      color: #fff;
      border: none;
    }
  }
}

.head-box {
  margin-bottom: 10px;
  font-weight: bold;
}

.ant-tabs > .ant-tabs-nav {
  margin: 0 !important;
}

.fRed {
  color: red;
}
</style>
